export const NOTICE_EVENT = 'notice';
